<template>
	<div class="login">
		<div class="login-top flex-between flex-center ">
			<img src="@/assets/images/logo.png"/>
			<router-link class="login-top-a" to="/">进入官网首页</router-link>
		</div>
		<div class="login-content">
			<div class="login-form">
				<div class="login-form-title">用户登录</div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
				  <el-form-item label="手机号码" prop="phone">
				    <el-input v-model="ruleForm.phone" placeholder="请输入您的登录手机号">
						<img  slot="prefix" class="input-icon" src="@/assets/images/login/phone.png"/>
					</el-input>
				  </el-form-item>
				  <el-form-item label="登录密码" prop="password">
				    <el-input v-model="ruleForm.password" type="password" placeholder="请输入登录密码">
						<img  slot="prefix" class="input-icon" src="@/assets/images/login/pwd.png"/>
					</el-input>
				  </el-form-item>
				</el-form>
				<div class="flex-between flex-center">
					<div class="login-label flex-start flex-center" @click="remmend = !remmend">
						<img v-if="remmend" src="@/assets/images/radio.png"/>
						<img v-else src="@/assets/images/no-radio.png"/>
						<div>记住密码</div>
					</div>
					
					<router-link class="login-label" to="/forget">忘记密码？</router-link>
				</div>
				<el-button class="login-button" type="primary" :loading="false" @click="submitForm('ruleForm')">登录</el-button>
			</div>
		</div>
		<div class="login-bottom">CopyRight @图迈商城2015-2025</div>
	</div>
</template>

<script>
	import {pwdLogin} from "@/api/login"
	export default {
		data(){
			return {
				ruleForm:{
					phone:"",
					password:""
				},
				rules:{
					phone: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					]
				},
				remmend:false
			}
		},
		mounted() {
		},
		methods:{
			submitForm(formName){
				this.$refs[formName].validate((valid) => {
					if (valid) {
						pwdLogin(this.ruleForm).then(res=>{
							if(res.code == 1000){
								this.$cookies.set('userToken', res.data.token);
								//同步用户信息
								this.$store.dispatch('fetchUser');
								this.$router.replace("/");
							}else{
								return this.$message.error(res.message);
							}
						})
					} else {
						return false;
				  }
				});
				
			}
		}
	}
</script>

<style scoped lang="scss">
	.login-label{
		margin-bottom: 24px;
		cursor: pointer;
		img{
			width: 16px;
			height: 16px;
			margin-right: 4px;
		}
		div{
			font-size: 16px;
			line-height: 24px;
			color: #1D2129;
	
		}
	}
	.login-button{
		width: 100%;
		height: 56px;
		border-radius: 4px;
		background: #E91A12;
		border: 0px;
		font-size: 20px;
		font-weight: 500;
		color: #FFFFFF;
	}
	::v-deep .el-button--primary:focus, .el-button--primary:hover{
		background: #E91A12;
		color: #FFFFFF;
	}
	.input-icon{
		width: 16px;
		height: 16px;
	}
	::v-deep .el-input__prefix{
		line-height:56px;
		left: 16px;
	}
	::v-deep .el-form-item__label{
		font-size: 16px;
		line-height: 28px;
		color: #1D2129;
		padding: 0px 0px 8px;
		&::before{
			display: none;
		}
	}
	::v-deep .el-form-item{
		margin: 0px 0px 10px;
	}
	::v-deep .el-input__inner{
		height: 56px;
		border-radius: 4px;
		border: 1px solid rgba(134, 144, 156, 0.3);
		font-size: 16px;
		outline: none;
	}
	::v-deep .el-input-group__prepend{
		background-color: #fff;
	}
	::v-deep .el-input--prefix .el-input__inner{
		padding-left: 40px;
	}
	
	.login{
		width: 100%;
		height: 100vh;
		.login-top{
			padding: 24px 60px;
			background-color: #fff;
			img{
				width: 153px;
				height: 48px;
				object-fit: cover;
			}
			.login-top-a{
				 font-size: 16px; 
				 line-height: 48px;
				 color: #E91A12;
				font-weight: 400;
			}
		}
		.login-content{
			height: calc(100vh - 96px - 72px);
			background-image: url(../assets/images/login/bg.png);
			background-position: center;
			background-size: 100% 100%;
			background-repeat: no-repeat;
			position: relative;
			.login-form{
				width: 480px;
				border-radius: 8px;
				background: #FFFFFF;
				box-shadow: 0px 4px 40px 0px rgba(6, 17, 53, 0.04);
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				padding: 72px 40px;
				box-sizing: border-box;
				.login-form-title{
					font-size: 24px;
					font-weight: 600;
					line-height: 28px;
					color: #1D2129;
					padding-bottom: 30px;
				}
			}
		}
		.login-bottom{
			height: 16px;
			opacity: 0.7;
			font-size: 12px;
			line-height: 16px;
			color: #9E9E9E;
			padding: 28px 0px;
			text-align: center;
		}
	}
</style>